import Vue from 'vue';
import VeeValidate from 'vee-validate';
import i18n, { defaultLocale } from '@/locales';

import en from './locales/en';
import fr from './locales/fr';

const config = {
  aria: true,
  classNames: {
    touched: 'touched',
    untouched: 'untouched',
    valid: 'is-valid',
    invalid: 'is-invalid',
    pristine: 'pristine',
    dirty: 'dirty',
  },
  classes: true,
  delay: 0,
  dictionary: {
    en,
    fr,
  },
  errorBagName: 'errors', // change if property conflicts
  events: 'input|blur',
  fieldsBagName: 'fields',
  i18n,
  i18nRootKey: 'validations',
  inject: false,
  locale: defaultLocale,
  strict: true,
  validity: false,
};

Vue.use(VeeValidate, config);
